<select [(ngModel)]="selectedYear" (ngModelChange)="onYearChange()">
    <option *ngFor="let year of years" [value]="year">{{ year }}</option>
</select>
